import React from "react";
import { Card } from "@/components/ui/card";

interface LegendItemProps {
  label: string;
  color?: string;
  gradient?: string;
}

const LegendItem: React.FC<LegendItemProps> = ({ label, color, gradient }) => {
  return (
    <div className="mb-2 flex w-37.5 items-center gap-2">
      <div
        className="size-6 shrink-0 rounded-lg"
        style={{ background: gradient ?? color }}
      />
      <span className="text-sm">{label}</span>
    </div>
  );
};

export const Legend: React.FC = () => {
  return (
    <Card className="p-4">
      <p className="mb-2 font-bold">Legend</p>
      <LegendItem label="Not Flooded" color="#06D6A0" />
      <LegendItem
        label="Building Flooded"
        gradient="linear-gradient(90deg, #FFD166 0%, #EF476F 100%)"
      />
      <LegendItem
        label="Parcel Flooded"
        gradient="linear-gradient(90deg, #5CDCEB 0%, #178FC2 100%)"
      />
    </Card>
  );
};
